//#region IMPORT
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setYear, setCustCd } from '../../../../Reducer/SearchReducer';
/** Components Import */
import {
  Unstable_Grid2 as Grid,
  Switch,
  Box,
  Tooltip,
  styled,
  tooltipClasses,
  Fab,
  Typography,
  Tabs,
  Tab,
} from '@mui/material';
import { AuthButton, Button } from '../../../../Components/MUIs';
/** AG-grid Import */
import 'ag-grid-enterprise';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import Commons from '../../../../Services/Common/Common';
/** Icons Import */
import dayjs from 'dayjs';

import { PropTypes } from 'prop-types';
import BUD_BASIC_02F from './../BUD_BASIC_02/BUD_BASIC_02F';
// eslint-disable-next-line no-unused-vars
import BUD_BASIC_01F from './../BUD_BASIC_01/BUD_BASIC_01F'; // 예제 확인 후 다시 사용할 수 있도록 유지
// Grand Total 예제 컴포넌트 (예제 확인용)
import BUD_BASIC_01_GRAND_TOTAL_EXAMPLE from './../BUD_BASIC_01/BUD_BASIC_01_GRAND_TOTAL_EXAMPLE';

import { BusinessCommon } from '../../../../Components/BusinessCommon';
import { GridFileUploadF } from '../../../../Components/Ui/GridFileUpload/GridFileUploadF';
import Draggable from 'react-draggable';
import { getColumnDefs1 } from './BUD_BASIC_ColumnDefs';
import { AMOUNT_UNIT_OPTIONS } from './../budgetAmountUnit';
import GridFunctions from '../../../../Services/agGrid/ag-Grid-functions';

//#endregion

function A11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

function CustomTabPanel(props) {
  const { children, value, index } = props;
  return (
    <React.Fragment>
      {value === index && (
        <Box
          sx={{
            width: '100%',
            height: '100%',
            minHeight: 0,
          }}
        >
          {children}
        </Box>
      )}
    </React.Fragment>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function BUD_BASIC(props) {
  //#region 변수
  const dispatch = useDispatch();
  const searchInfo = useSelector((state) => state.SearchInfo);
  // 커스터마이징된 Tooltip 생성
  const LargeTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} arrow classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: '#4CAF50', // 본체 배경 초록
      color: '#fff',
      fontSize: '0.9rem',
      padding: theme.spacing(1),
    },
    [`& .${tooltipClasses.arrow}`]: {
      color: '#4CAF50', // 꼬리도 동일 색으로!
    },
  }));
  //#endregion

  //#region 웹
  // 자사양식 그리드
  const columnDefs1 = getColumnDefs1(props);
  //#endregion

  return (
    <Grid container spacing={2} columns={{ xs: 4, sm: 8, md: 12 }}>
      <Grid xs={4} md={12}>
        <Draggable>
          <Fab
            sx={{
              position: 'absolute',
              bottom: 40,
              right: 40,
            }}
            variant="extended"
          >
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'flex-end',
                alignItems: 'center',
              }}
            >
              <LargeTooltip
                title="자사양식 업로드 시 사용하세요"
                arrow
                placement="top"
              >
                <Switch
                  checked={props.useCustomFormat}
                  onChange={props.HandleToggleChange}
                  color="primary"
                />
              </LargeTooltip>
              <Typography sx={{ pr: '12px' }}>자사양식</Typography>
            </Box>
          </Fab>
        </Draggable>
        <AuthButton
          menuId="BudgetManagement"
          searchYn="Y"
          addYn="Y"
          saveYn="Y"
          searchBox={props.useCustomFormat ? 'N' : 'Y'}
          printYn={props.useCustomFormat ? 'N' : 'Y'}
          multiPrintYn={
            props.useCustomFormat ? 'N' : props.value === 1 ? 'Y' : 'N'
          }
          printItem={props.value === 1 ? props.printItem2 : []}
          saveClick={() => {
            if (!props.validateSelection()) return;

            if (props.useCustomFormat) {
              props.Save1();
            } else {
              if (props.value === 0) {
                props.setSaveClick1(true);
              } else if (props.value === 1) {
                props.setSaveClick2(true);
              }
            }
          }}
          printClick={() => {
            if (!props.validateSelection()) return;

            if (props.useCustomFormat) {
              // 자사양식일 경우 인쇄 없음
            } else {
              if (props.value === 0) {
                props.setPrintClick1(true);
              } else if (props.value === 1) {
                // printItem을 사용하므로 여기서는 아무것도 하지 않음
                // printItem의 onClick에서 각각 처리됨
              }
            }
          }}
          conditions={[
            ...(props.useCustomFormat
              ? []
              : [
                  {
                    type: 'datePicker',
                    views: ['year'],
                    openTo: 'year',
                    title:
                      props.lanInfo.length === 0
                        ? ''
                        : props.lanInfo.find(
                            (f) => f.lanType !== 'MENU' && f.lanId === 'Period'
                          ).lanNm,
                    name: Commons.IsMobile()
                      ? searchInfo.year || dayjs().format('YYYY')
                      : '조회연도',
                    value: searchInfo.year ? dayjs(searchInfo.year) : dayjs(),
                    onChange: (date) => {
                      let changeYear = dayjs(date).format('YYYY');
                      if (date) {
                        dispatch(setYear(changeYear));
                        if (props.value === 0) {
                          props.setSearchClick1(true);
                        } else if (props.value === 1) {
                          props.setSearchClick2(true);
                        }
                      }
                    },
                    currentLocale: 'ko',
                    format: 'YYYY',
                  },
                ]),
            ...(props.userInfo.authCd === 'ADMIN'
              ? [
                  {
                    type: 'combo',
                    name: '회사',
                    items: searchInfo.coList || [],
                    value: searchInfo.coCd || '',
                    onChange: (e) => {
                      props.handleCoChange(e);
                      if (props.useCustomFormat) {
                        props.SearchLogic2();
                      } else {
                        if (props.value === 0) {
                          props.setSearchClick1(true);
                        } else if (props.value === 1) {
                          props.setSearchClick2(true);
                        }
                      }
                    },
                  },
                ]
              : []),
            {
              type: 'combo',
              name: '사업장',
              items: searchInfo.custList || [],
              value: searchInfo.custCd || '',
              onChange: (e) => {
                dispatch(setCustCd(e));
                if (props.useCustomFormat) {
                  props.SearchLogic2();
                } else {
                  if (props.value === 0) {
                    props.setSearchClick1(true);
                  } else if (props.value === 1) {
                    props.setSearchClick2(true);
                  }
                }
              },
            },
            ...(props.useCustomFormat
              ? []
              : [
                  {
                    type: 'combo',
                    name: '금액단위',
                    items: AMOUNT_UNIT_OPTIONS,
                    value: props.amountUnit || 'THOUSAND',
                    onChange: (value) => {
                      props.setAmountUnit?.(value);
                    },
                  },
                ]),
          ]}
          grids={
            props.useCustomFormat ? (
              <BusinessCommon
                title1={'기본정보'}
                title2={'자사양식 미리보기'}
                gridId={props.gridId1}
                getRowId={(params) => {
                  return params.data.no;
                }}
                addClick1={() => {
                  if (!props.validateSelection()) return;

                  GridFileUploadF('', props.gridRef1, props, {
                    blockVideo: true,
                  });
                }}
                refreshClick1={() => {
                  if (!props.validateSelection()) return;

                  props.SearchLogic1();
                }}
                deleteClick1={(e) => {
                  if (!props.validateSelection()) return;

                  const newRowExists = props.selectedRowData1.some(
                    (row) => row.newYn === 'Y'
                  );

                  if (!newRowExists) {
                    props.MarkedForDeletion1(props.selectedRowData1);
                  } else {
                    props.NewYnErrorMsg();
                  }
                }}
                gridRef={props.gridRef1}
                columnDefs={columnDefs1}
                rowData={props.rowData1}
                setSelectedRowData={props.setSelectedRowData1}
                setChangedRowData={props.setChangedRowData1}
                rowSelection={'multiple'}
                onCellClicked={(e) => {
                  const gridApi = props.gridRef1.current.api;
                  const clickedRowIndex = e.rowIndex;

                  const isCheckboxClick = e.event?.target?.type === 'checkbox';

                  if (!isCheckboxClick) {
                    gridApi.ensureIndexVisible(clickedRowIndex, 'middle');

                    const copied = JSON.parse(JSON.stringify(e.data));
                    props.HandleRowSelection1(copied, clickedRowIndex);

                    gridApi
                      .getDisplayedRowAtIndex(clickedRowIndex)
                      ?.setSelected(true, false);
                  }
                }}
                onSelectionChanged={() => {
                  const gridApi = props.gridRef1?.current?.api;
                  const selectedNodes = gridApi.getSelectedNodes();
                  const selectedData = selectedNodes.map((n) => n.data);
                  props.selectedRowNosRef1.current = new Set(
                    selectedData.map((r) => r.no)
                  );
                  props.setSelectedRowData1(selectedData);
                }}
                onCellValueChanged={(e) => {
                  GridFunctions.onCellValueChanged(
                    e,
                    props.gridRef1,
                    props.setChangedRowData1
                  );
                }}
                viewMode="preview"
                selectedRowData={props.selectedRowData1}
                fileNameField="saveName"
                filePathField="filePath"
                other1={
                  <>
                    <Button
                      name="멀티 다운로드"
                      onClick={() => {
                        if (!props.validateSelection()) return;

                        if (props.selectedRowData1?.length === 0) {
                          props.dispatch(
                            props.showSnackbar({
                              message: '다운로드할 항목을 먼저 선택해 주세요.',
                              type: 'warning',
                            })
                          );

                          return;
                        }

                        props.selectedRowData1.forEach((item, index) => {
                          setTimeout(() => {
                            props.DownloadLogic1(item);
                          }, index * 300);
                        });
                      }}
                    />
                  </>
                }
              />
            ) : (
              <React.Fragment>
                <Box sx={{ mb: 1 }}>
                  <Tabs
                    value={props.value}
                    onChange={props.HandleChange}
                    aria-label="basic tabs example"
                  >
                    <Tab
                      label="집행내역"
                      {...A11yProps(0)}
                      sx={{
                        fontSize: '0.95rem',
                        fontWeight: 'bold',
                        color: '#000',
                      }}
                    />
                    <Tab
                      label="예산편성"
                      {...A11yProps(1)}
                      sx={{
                        fontSize: '0.95rem',
                        fontWeight: 'bold',
                        color: '#000',
                      }}
                    />
                  </Tabs>
                </Box>
                <CustomTabPanel value={props.value} index={0}>
                  {/* Grand Total 예제 컴포넌트 (예제 확인용) */}
                  {/* <BUD_BASIC_01_GRAND_TOTAL_EXAMPLE
                    ref={props.searchLogic1Ref}
                    gridRef1={props.gridRef1}
                    rowData1={props.rowData1}
                    setRowData1={props.setRowData1}
                    selectedRowData1={props.selectedRowData1}
                    setSelectedRowData1={props.setSelectedRowData1}
                    changedRowData1={props.changedRowData1}
                    setChangedRowData1={props.setChangedRowData1}
                    validateSelection={props.validateSelection}
                    SearchLogic1={props.SearchLogic1}
                  /> */}
                  {/* 기존 컴포넌트 (예제 확인 후 다시 활성화하려면 주석 해제) */}
                  <BUD_BASIC_01F
                    ref={props.searchLogic1Ref}
                    amountUnit={props.amountUnit}
                    filterClick1={props.filterClick1}
                    setFilterClick1={props.setFilterClick1}
                    searchClick1={props.searchClick1}
                    setSearchClick1={props.setSearchClick1}
                    addClick1={props.addClick1}
                    setAddClick1={props.setAddClick1}
                    saveClick1={props.saveClick1}
                    setSaveClick1={props.setSaveClick1}
                    deleteClick1={props.deleteClick1}
                    setDeleteClick1={props.setDeleteClick1}
                    printClick1={props.printClick1}
                    setPrintClick1={props.setPrintClick1}
                  />
                </CustomTabPanel>
                <CustomTabPanel value={props.value} index={1}>
                  <BUD_BASIC_02F
                    amountUnit={props.amountUnit}
                    filterClick2={props.filterClick2}
                    setFilterClick2={props.setFilterClick2}
                    searchClick2={props.searchClick2}
                    setSearchClick2={props.setSearchClick2}
                    addClick2={props.addClick2}
                    setAddClick2={props.setAddClick2}
                    saveClick2={props.saveClick2}
                    setSaveClick2={props.setSaveClick2}
                    deleteClick2={props.deleteClick2}
                    setDeleteClick2={props.setDeleteClick2}
                    printClick2={props.printClick2}
                    setPrintClick2={props.setPrintClick2}
                    printClick2Plan={props.printClick2Plan}
                    setPrintClick2Plan={props.setPrintClick2Plan}
                  />
                </CustomTabPanel>
              </React.Fragment>
            )
          }
        />
      </Grid>
    </Grid>
  );
}

export default BUD_BASIC;
